import { render } from "./SettingsView.vue?vue&type=template&id=ab6890b2&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=ab6890b2&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-ab6890b2"

export default script